import React, { useMemo } from "react";

import { Row, Col } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Input from "shared/components/Input";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { useInfo } from "utils/hooks/info";

const Component = ({
  values,
  onChange,
  countriesQuery: { data: countriesData, loading: countriesoading },
  civilitiesQuery: { data: civilitiesData, loading: civilitiesLoading },
}) => {
  const {
    info: { languages: languagesData },
  } = useInfo();
  const { t } = useTranslation(NAME_SPACES.ACCOUNT);
  const LABELS = t("CONTACT", { returnObjects: true });
  const civilities = useMemo(
    () =>
      (civilitiesData?.map(({ desc, code }) => ({ label: desc, value: code })))||[],
    [civilitiesData],
  );
  const countries = useMemo(
    () => (countriesData?.map(({ desc, code }) => ({ label: desc, value: code })))||[],
    [countriesData],
  );
  const languages = useMemo(
    () => (languagesData?.map(({ desc, code }) => ({ label: desc, value: code })))||[],
    [languagesData],
  );

  return (
    <>
      <div className={"col"}>
        <p className={"title"}>{LABELS.TITLE}</p>
        <Input
          mode="select"
          placeholder={LABELS.CIVILITY}
          items={civilities}
          loading={civilitiesLoading}
          onSelect={(civilityCode) => onChange({ ...values, civilityCode })}
          value={values.civilityCode}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.LAST_NAME}
          onChange={(e) => onChange({ ...values, name: e.target.value })}
          value={values.name}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.FIRST_NAME}
          onChange={(e) => onChange({ ...values, firstname: e.target.value })}
          value={values.firstname}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.ADDRESS}
          onChange={(e) => onChange({ ...values, address1: e.target.value })}
          value={values.address1}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.COMPLEMENT}
          onChange={(e) => onChange({ ...values, address2: e.target.value })}
          value={values.address2}
        />
        <Space h={24} />
        <Row gutter={[16, 24]}>
          <Col lg={14} xs={24}>
            <Input
              placeholder={LABELS.CITY}
              onChange={(e) => onChange({ ...values, town: e.target.value })}
              value={values.town}
            />
          </Col>
          <Col lg={10} xs={24}>
            <Input
              placeholder={LABELS.POSTAL_CODE}
              onChange={(e) =>
                onChange({ ...values, postCode: e.target.value })
              }
              value={values.postCode}
            />
          </Col>
        </Row>
        <Space h={24} />
        <Input
          mode="select"
          placeholder={LABELS.COUNTRY}
          items={countries}
          loading={countriesoading}
          onSelect={(countryCode) => onChange({ ...values, countryCode })}
          value={values.countryCode}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.EMAIL}
          value={values.email || ""}
          disabled={true}
        />
        <Space h={24} />
        <Input
          placeholder={LABELS.PHONE}
          onChange={(e) => onChange({ ...values, cellPhone: e.target.value })}
          value={values.cellPhone}
        />
        <Space h={24} />
        <Input
          mode="select"
          placeholder={LABELS.LANGUAGE}
          items={languages}
          onChange={(value) => onChange({ ...values, languageCode: value })}
          value={values.languageCode}
        />
        <Space h={24} />
      </div>
      <Space h={24} />
    </>
  );
};

Component.propTypes = {
  countriesQuery: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        desc: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
      }),
    ).isRequired,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  civilitiesQuery: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        desc: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
      }),
    ).isRequired,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  values: PropTypes.shape({
    civilityCode: PropTypes.string.isRequired,
    firstname: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    town: PropTypes.string.isRequired,
    postCode: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    cellPhone: PropTypes.string.isRequired,
    languageCode: PropTypes.string.isRequired,
    geolocalized: PropTypes.bool.isRequired,
    dataList: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  visible: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
